import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "title overflow-hidden"
};
const _hoisted_2 = {
  class: "truncate block"
};
const _hoisted_3 = {
  class: "content-block relative p-2"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 1,
  class: "content"
};
const _hoisted_6 = {
  class: "footer-btn"
};
import { ref, watch } from 'vue';
import { marked } from 'marked';
export default /*@__PURE__*/_defineComponent({
  __name: 'NewsCard',
  props: {
    isMd: {
      type: Boolean,
      default: false
    },
    title: {},
    content: {},
    checked: {
      type: Boolean,
      default: false
    },
    hideBtn: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:checked", "toggleFull", "click"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const showContent = ref(props.content);
    const updateModelValue = val => {
      emits('update:checked', val);
    };
    watch(() => props.content, async val => {
      if (!props.isMd || !val) return;
      showContent.value = await marked.parse(val);
    }, {
      immediate: true
    });
    const handleClick = () => {
      emits('update:checked', !props.checked);
    };
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_i_home_full = _resolveComponent("i-home-full");
      return _openBlock(), _createElementBlock("div", {
        class: "news-card px-2",
        onClick: handleClick
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_checkbox, {
        "model-value": __props.checked,
        "onUpdate:modelValue": updateModelValue,
        class: "truncate-check",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)]),
        _: 1
      }, 8, ["model-value"])]), _createElementVNode("div", _hoisted_3, [__props.isMd ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "content",
        innerHTML: showContent.value
      }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.content), 1)), _createElementVNode("div", _hoisted_6, [__props.content && !__props.hideBtn ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "btn-box",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => emits('toggleFull'), ["stop"]))
      }, [_createVNode(_component_i_home_full, {
        class: "w-2 h-2"
      }), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "ml-1"
      }, "查看/编辑", -1))])) : _createCommentVNode("", true)])])]);
    };
  }
});